<div class="login">
  <div class="login__inside">
  
    <form name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate>
      <fieldset>
        <label for="users-username">Uživatelské jméno</label>
        <div class="input">
          <input type="text" id="username" name="username" [(ngModel)]="model.username" #username="ngModel" required />
        </div>
        <label for="users-username">Heslo</label>
        <div class="input">
          <input type="password" id="password" name="password" [(ngModel)]="model.password" #password="ngModel" required />
        </div>
      </fieldset>
      <div class="login__submit">
        <button type="submit" class="submit cta cta--green cta--login cta--uppercase cta--ico-right">Přihlásit <span class="ico-angle-right"></span></button>
      </div>
    </form>
  </div>
</div>